(() => {
  'use strict';
  const init = root => {
    const scope = root.querySelector('[data-cinema]');
    if (!scope || scope.dataset.cinemaBound) return;
    scope.dataset.cinemaBound = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = navigator.connection?.saveData;
    const videos = [...scope.querySelectorAll('video[data-gc-video]')];
    const motionButton = scope.querySelector('[data-gc-motion]');
    let paused = reduced.matches, visible = true;
    const updateMotion = () => {
      scope.dataset.paused = String(paused);
      scope.classList.toggle('gc-motion-active', !paused);
      motionButton.textContent = paused ? scope.dataset.labelPlay : scope.dataset.labelPause;
      motionButton.setAttribute('aria-pressed', String(paused));
      videos.forEach(v => {
        const sceneActive = !v.dataset.sceneVideo || v.dataset.sceneVideo === (scope.dataset.scene || 'day');
        if (paused || !visible || document.hidden || !sceneActive) v.pause();
        else {
          if (!v.getAttribute('src') && v.dataset.src && !saveData) v.src = v.dataset.src;
          if (v.getAttribute('src')) v.play().catch(() => {});
        }
      });
      if (paused) scope.querySelectorAll('.gc-await').forEach(e => e.classList.remove('gc-await'));
    };
    videos.forEach(v => v.addEventListener('playing', () => v.classList.add('gc-video-ready')));
    motionButton.addEventListener('click', () => {paused = !paused; updateMotion();});
    reduced.addEventListener('change', e => {paused = e.matches; updateMotion();});
    document.addEventListener('visibilitychange', updateMotion);
    new IntersectionObserver(entries => {visible = entries[0].isIntersecting; updateMotion();}, {threshold:.1}).observe(scope.querySelector('.gta-hero'));
    scope.querySelectorAll('[data-gc-scene]').forEach(b => b.addEventListener('click', () => {
      scope.dataset.scene = b.dataset.gcScene;
      scope.querySelectorAll('[data-gc-scene]').forEach(s => s.setAttribute('aria-pressed', String(s === b)));
      updateMotion();
    }));
    const reveals = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) {e.target.classList.remove('gc-await'); reveals.unobserve(e.target);}
    }), {threshold:.12});
    if (!paused) scope.querySelectorAll('.gc-reveal').forEach(e => {e.classList.add('gc-await'); reveals.observe(e);});
    const chapterLinks = [...scope.querySelectorAll('.gc-chapters a')];
    const chapterObserver = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) chapterLinks.forEach(a => a.setAttribute('aria-current', String(a.hash === '#' + e.target.id)));
    }), {rootMargin:'-15% 0px -60% 0px'});
    chapterLinks.forEach(a => {const el=scope.querySelector(a.hash);if(el)chapterObserver.observe(el);});
    let ticking=false;
    const progress=()=>{
      const total=document.documentElement.scrollHeight-innerHeight;
      scope.style.setProperty('--gc-progress',String(total>0?Math.min(1,Math.max(0,scrollY/total)):0));ticking=false;
    };
    addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(progress);}},{passive:true});
    progress();updateMotion();
    const cards=[...scope.querySelectorAll('#gta-builds .gk-card')];
    const fmt=n=>new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'}).format(n);
    const readCard=card=>{
      const option=card.querySelector('select')?.selectedOptions[0];
      const price=option?.dataset.price ? Number(option.dataset.price)/100 : Number(card.querySelector('[data-gk-price]')?.textContent.replace(/[^0-9.]/g,''));
      return {title:card.querySelector('h3')?.textContent.trim()||'',specs:card.querySelector('[data-gk-specs]')?.textContent.trim()||'',price,url:card.querySelector('.gk-card-bottom')?.href||card.querySelector('h3 a')?.href,image:card.querySelector('img')?.src,gpu:option?.textContent.trim()||''};
    };
    const selected=new Set(),bar=scope.querySelector('[data-gc-compare-bar]'),dialog=scope.querySelector('[data-gc-compare-dialog]'),grid=scope.querySelector('[data-gc-compare-grid]');
    const toast=scope.querySelector('[data-gc-toast]');let toastTimer;
    const tell=message=>{toast.textContent=message;toast.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.hidden=true,3500);};
    const syncCompare=()=>{bar.hidden=!selected.size;scope.querySelector('[data-gc-compare-count]').textContent=String(selected.size);};
    cards.forEach(card=>{
      const label=document.createElement('label');label.className='gc-compare-pick';
      const text=document.createElement('span');text.textContent=scope.dataset.labelCompare;
      const check=document.createElement('input');check.type='checkbox';check.setAttribute('aria-label',scope.dataset.labelCompare+' '+readCard(card).title);
      check.addEventListener('change',()=>{
        if(check.checked&&selected.size===3){check.checked=false;tell(scope.dataset.labelCompareLimit);return;}
        check.checked?selected.add(card):selected.delete(card);syncCompare();
      });
      label.append(text,check);card.append(label);
    });
    const makeResult=(p,comparison=false)=>{
      const article=document.createElement('article');
      if(comparison&&p.image){const img=document.createElement('img');img.src=p.image;img.alt=p.title;article.append(img);}
      const h=document.createElement('h3');h.textContent=p.title;
      const details=document.createElement('p');details.textContent=p.specs;
      const price=document.createElement('strong');price.textContent=fmt(p.price)+' CAD';
      const link=document.createElement('a');link.href=p.url;link.textContent=scope.dataset.labelOpen;
      article.append(h,details,price,link);return article;
    };
    scope.querySelector('[data-gc-open-compare]').addEventListener('click',()=>{
      if(selected.size<2){tell(scope.dataset.labelCompareEmpty);return;}
      grid.style.setProperty('--compare-count',selected.size);
      grid.replaceChildren(...[...selected].map(c=>makeResult(readCard(c),true)));dialog.showModal();
    });
    scope.querySelector('[data-gc-close-compare]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    scope.querySelector('[data-gc-clear-compare]').addEventListener('click',()=>{selected.clear();cards.forEach(c=>c.querySelector('.gc-compare-pick input').checked=false);syncCompare();});
  };
  const start=()=>init(document);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start):start();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
